angular.module('gym.components').directive('membershipSecondStep', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/membership/membership_second_step.html.slim'),
    scope: {
      gym: '=',
      membership: '=',
      save: '&',
      cancel: '&'
    },
    controller: ["$scope", "$filter", "MembershipIntervalUnits", "PeriodicalUnits", "ReactModal", function($scope, $filter, MembershipIntervalUnits, PeriodicalUnits, ReactModal) {
      var membership;
      $scope.membership.cc_invoice_receipt_enabled = !!$scope.membership.cc_invoice_receipts_to;
      membership = $scope.membership;
      $scope.membership_interval_unit_pairs = _.pairs(MembershipIntervalUnits);
      $scope.charge_interval_unit_pairs = _.pairs(_.omit(MembershipIntervalUnits, 'years'));
      $scope.automaticRescheduleLimits = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      $scope.currency = $scope.gym.attributes.currency_symbol;
      $scope.membershipTaxRateSet = $scope.gym.attributes.gym_membership_detail.membership_tax_rate_set;
      $scope.onUpfrontCostChange = function() {
        if ($scope.membership.cost_upfront && !$scope.membership.upfront_payment_on) {
          return $scope.membership.upfront_payment_on = $scope.gym.attributes.today;
        }
      };
      $scope.onSendInvoiceReceiptChanged = function() {
        $scope.membership.tax_status = '';
        if (!$scope.membership.send_invoice_receipts) {
          $scope.membership.cc_invoice_receipt_enabled = false;
          return $scope.membership.cc_invoice_receipts_to = '';
        }
      };
      $scope.onCcInvoiceReceiptToggleChanged = function() {
        if (!$scope.membership.cc_invoice_receipt_enabled) {
          return $scope.membership.cc_invoice_receipts_to = '';
        }
      };
      $scope.onPlanTypeChanged = function() {
        if ($scope.isUpfront()) {
          membership.recurring_payments_start_on = void 0;
          return membership.cost_repeat = void 0;
        }
      };
      $scope.isUpfront = function() {
        return membership.plan_type === 'upfront';
      };
      $scope.saveMembership = function() {
        var base;
        (base = $scope.membership).cost_upfront || (base.cost_upfront = 0);
        $scope.isLoading = true;
        return $scope.save().finally(function() {
          return $scope.isLoading = false;
        });
      };
      $scope.getMembershipTerm = function() {
        var number, unit;
        if (membership.term_number) {
          number = membership.term_number;
          unit = $filter('pluralize')(membership.term_unit, number);
          return `for ${number} ${unit}`;
        } else {
          return 'until further notice';
        }
      };
      $scope.getReccuringPeriod = function() {
        var interval_number, interval_unit;
        interval_number = membership.charge_interval_number;
        interval_unit = membership.charge_interval_unit;
        if (interval_number === 1) {
          return PeriodicalUnits[interval_unit];
        } else {
          return `every ${interval_number} ${interval_unit}`;
        }
      };
      $scope.onAutomaticRescheduleToggle = function() {
        if ($scope.membership.perform_automatic_reschedule) {
          $scope.membership.automatic_reschedule_days = 1;
          return $scope.membership.automatic_reschedule_limit = 3;
        } else {
          $scope.membership.automatic_reschedule_days = 0;
          return $scope.membership.automatic_reschedule_limit = 0;
        }
      };
      $scope.hasSinglePayment = function() {
        return $scope.membership.cost_upfront && $scope.membership.upfront_payment_on;
      };
      $scope.isUpfrontPaymentBeforeToday = function() {
        return $scope.membership.cost_upfront && moment($scope.membership.upfront_payment_on).isBefore(moment().tz($scope.gym.tz), 'day');
      };
      $scope.isRecurringPaymentBeforeToday = function() {
        return $scope.membership.recurring_payments_start_on && moment($scope.membership.recurring_payments_start_on).isBefore(moment().tz($scope.gym.tz), 'day');
      };
      $scope.isRecurringPaymentDateAfterExpiry = function() {
        return $scope.membership.recurring_payments_start_on && $scope.membership.term_number && moment($scope.membership.recurring_payments_start_on).isAfter(moment($scope.membership.start_date).add($scope.membership.term_number, $scope.membership.term_unit).subtract(1, 'day'));
      };
      $scope.autoFailPolicy = (function() {
        switch ($scope.gym.attributes.gym_membership_detail.autofail_override_policy) {
          case 'autofail_policy_skipped':
            return $scope.autoFailPolicy = 'Skipped';
          case 'autofail_policy_failed':
            return $scope.autoFailPolicy = 'Failed';
          case 'autofail_policy_process_manually':
            return $scope.autoFailPolicy = 'Process Manually';
          case 'autofail_policy_paid_by_cash':
            return $scope.autoFailPolicy = 'Paid (by Cash)';
          case 'autofail_policy_paid_by_pos':
            return $scope.autoFailPolicy = 'Paid (by POS)';
          case 'autofail_policy_paid_by_other':
            return $scope.autoFailPolicy = 'Paid (by Other)';
          default:
            return $scope.autoFailPolicy = 'Failed';
        }
      })();
      $scope.hasRecurringPayment = function() {
        return $scope.membership.cost_repeat && $scope.membership.recurring_payments_start_on && $scope.membership.charge_interval_number;
      };
      return $scope.openPaymentDateInPastModal = function() {
        return ReactModal.open({
          component: 'MembershipPaymentDateWarningModal',
          props: {
            autoFailPolicy: $scope.autoFailPolicy
          }
        });
      };
    }]
  };
});
